var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-grid"},[_c('iframe',{attrs:{"src":_vm.adjustedURL,"frameBorder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }